var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWatchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.67116 2C8.63871 2 7.73875 2.70267 7.48834 3.70429L7.16332 5.00441C8.53635 4.05333 10.2029 3.49609 11.9997 3.49609C13.7967 3.49609 15.4636 4.05356 16.8368 5.00499L16.5117 3.70429C16.2612 2.70267 15.3613 2 14.3288 2H9.67116Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5032 11.9997C19.5032 16.1438 16.1438 19.5032 11.9997 19.5032C7.89627 19.5032 4.49619 16.0497 4.49609 11.9998C4.49619 7.85441 7.85698 4.49609 11.9997 4.49609C16.0935 4.49609 19.4965 7.91061 19.5032 11.9997ZM11.8452 9.66046C10.9541 8.76943 9.50949 8.76943 8.61846 9.66046C7.72744 10.5515 7.72744 11.9961 8.61846 12.8872L11.0605 15.3292C11.5782 15.847 12.4177 15.8472 12.9358 15.3298L15.3819 12.8872C16.273 11.9962 16.273 10.5515 15.3819 9.66048C14.4909 8.76945 13.0463 8.76945 12.1552 9.66048L12.0002 9.81551L11.8452 9.66046Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.9997 20.5032C10.2028 20.5032 8.5362 19.9459 7.16313 18.9948L7.48834 20.2956C7.73875 21.2972 8.63871 21.9998 9.67115 21.9998H14.3288C15.3613 21.9998 16.2612 21.2972 16.5117 20.2956L16.837 18.9942C15.4638 19.9457 13.7968 20.5032 11.9997 20.5032Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchIcon);
export default __webpack_public_path__ + "static/media/WatchIcon.0759048c1304202de91358e1b978018b.svg";
export { ForwardRef as ReactComponent };